/**
 * Central map of all payment codes → display info.
 * Used by CheckoutPage, UpiSection, CardSection, NetBankingSection, WalletSection.
 */

// Payment type code → label + sidebar icon hint
export const PAYMENT_TYPE_INFO = {
  UP: { label: "UPI",         iconType: "upi"    },
  CC: { label: "Credit Card", iconType: "card"   },
  DC: { label: "Debit Card",  iconType: "card"   },
  NB: { label: "Net Banking", iconType: "bank"   },
  WL: { label: "Wallet",      iconType: "wallet" },
};

// MOP code → label + logo path (null = use MUI icon)
export const MOP_INFO = {
  // ── Cards ────────────────────────────────────────
  VISA:        { label: "Visa",                  logo: "/images/cards/visa.svg"   },
  MASTERCARD:  { label: "Mastercard",            logo: "/images/cards/master.svg" },
  RUPAY:       { label: "RuPay",                 logo: "/images/cards/rupey.png"  },
  AMEX:        { label: "American Express",      logo: "/images/cards/amex.svg"   },
  DINERS:      { label: "Diners Club",           logo: "/images/cards/diner.svg"  },

  // ── Banks ─────────────────────────────────────────
  HDFC:        { label: "HDFC Bank",             logo: null },
  ICICI:       { label: "ICICI Bank",            logo: null },
  SBI:         { label: "State Bank of India",   logo: null },
  AXIS:        { label: "Axis Bank",             logo: null },
  KOTAK:       { label: "Kotak Mahindra Bank",   logo: null },
  BOB:         { label: "Bank of Baroda",        logo: null },
  PNB:         { label: "Punjab National Bank",  logo: null },
  YES:         { label: "Yes Bank",              logo: null },
  INDUSIND:    { label: "IndusInd Bank",         logo: null },

  // ── Wallets ───────────────────────────────────────
  PAYTM:       { label: "Paytm",     logo: "/images/paytm.png"    },
  PHONEPE:     { label: "PhonePe",   logo: "/images/phonepay.png" },
  AMAZONPAY:   { label: "Amazon Pay",logo: "/images/amazon.png"   },
};

// UPI app display entries (shown in the Intent sub-section on mobile)
// `scheme` is the app-specific URI prefix — replaces the leading "upi://" in the intentLink.
// e.g. intentLink = "upi://paycom/<blob>" → Paytm = "paytmmp://paycom/<blob>"
export const UPI_APPS = [
  { name: "PhonePe",    logo: "/images/phonepay.png",  scheme: "phonepe://"  },
  { name: "Google Pay", logo: "/images/googlepay.png", scheme: "tez://upi/"  },
  { name: "Paytm",      logo: "/images/paytm.png",     scheme: "paytmmp://"  },
  { name: "BHIM",       logo: "/images/bhim.png",      scheme: "upi://"      },
  { name: "Other Apps", logo: null,                    scheme: "upi://"      },
];

/**
 * Swap the "upi://" prefix for the app's own scheme.
 * All UPI apps understand the paycom/<blob> path regardless of the scheme prefix.
 * "Other Apps" keeps "upi://" → OS shows the standard app chooser.
 */
export const buildAppUrl = (intentLink, scheme) => {
  if (!intentLink) return "";
  if (intentLink.startsWith("upi://")) {
    console.log(scheme + intentLink.slice("upi://".length));
    return scheme + intentLink.slice("upi://".length);
  }
  return intentLink;
};

// ── Card network auto-detection ───────────────────────────────
const CARD_PATTERNS = {
  VISA:       /^4/,
  MASTERCARD: /^5[1-5]|^2[2-7]/,
  AMEX:       /^3[47]/,
  DINERS:     /^3(?:0[0-5]|[68])/,
  RUPAY:      /^(60|65|81|82|508)/,
};

export const detectCardNetwork = (cardNumber) => {
  const num = String(cardNumber).replace(/\s/g, "");
  for (const [code, pattern] of Object.entries(CARD_PATTERNS)) {
    if (pattern.test(num)) return code;
  }
  return null;
};
